import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { AuctionEntity, AuctionFacade } from 'libs/gb-front/auction/data-access/src'
import { ItemTypeEnum } from 'libs/gb-front/item/data-access/src/lib/+state/items.models'
import { GbDialogData } from './message-data.models'
import { ItemEntity } from 'libs/gb-front/selected-item/data-access/src/lib/+state/selected-item.models'
import { Router } from '@angular/router'
import { AccountEnum } from 'libs/gb-front/account/feature/src/lib/gb-account.constants'

@Component({
  selector: 'gb-message-dialog',
  templateUrl: './gb-message-dialog.component.html',
  styleUrls: ['./gb-message-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GbMessageDialogComponent {
  title!: string
  body!: string
  activityFeed: boolean
  messageType: 'success' | 'warning' | 'message'
  item!: ItemEntity | null
  itemTypeEnum = ItemTypeEnum
  payment!: boolean
  eventTicket!: boolean

  auction$ = this.auctionFacade.auction$

  constructor(
    private auctionFacade: AuctionFacade,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) data: GbDialogData,
  ) {
    this.title = data.title || ''
    this.body = data.body || ''
    this.activityFeed = data.activityFeed || false
    this.messageType = data.messageType || 'message'
    this.item = data.item || null
    this.payment = !!data.payment
    this.eventTicket = !!data.eventTicket
  }

  getCloseButtonLabel(auction: AuctionEntity): string {
    return auction.enable_activity_feed && this.activityFeed
      ? 'GB_MESSAGE_DIALOG_CLOSE_BUTTON_TEXT'
      : 'GB_MESSAGE_DIALOG_CLOSE_BUTTON_TEXT_NO_ACTIVITY_FEED'
  }

  navigateToEventTickets(auction: AuctionEntity): void {
    this.router.navigate([`${auction?.url_name}/${AccountEnum.Account}/${AccountEnum.AccountEventTickets}`])
  }
}
